import { BydOrganisationFonctionInterface } from '../interfaces/byd-organisation-fonction.interface';

export class BydOrganisationFonction implements BydOrganisationFonctionInterface {
  /**
   * Right ID.
   */
  rightId: number;

  /**
   * Right label
   */
  label: string;

  /**
   * is Right Enabled
   */
  enabled: boolean;

  /**
   * DsOrganisationFonction constructor.
   *
   * @param json DsOrganisationFonctionInterface
   */
  constructor(json: BydOrganisationFonctionInterface) {
    this.rightId = json?.rightId;
    this.label = json?.label;
    this.enabled = json?.enabled;
  }
}
